module.exports = __webpack_public_path__ + "img/logo-light.fbcfd686.svg";